import React, { useEffect, useState, useContext } from 'react'
import SettingsHeader from './SettingsHeader'
import SettingsInner from './SettingsInner'
import { appContext } from '../../App'
import { getVATSettings, saveVATSettings, getWarehouses, getWarehouseById, saveWarehouse,
  deleteWarehouse } from '../settings/SettingsFunctions'

export const settingsControllerContext = React.createContext()

function useSettingsController(props) {
  const app = useContext(appContext)
  const [vatSettings, setVatSettings] = useState(null)

  const updateVATSettings = async (vat_value) => {
    setVatSettings({value: vat_value}) // Trigger rerender
    /** Necessary because at this point vatSettings is not yet updated until rerendered
     *  and we didn't wait for that before calling saveVATSettings()
    */
    vatSettings.value = vat_value
    return await saveVATSettings(app, vatSettings)
  }

  useEffect(() => {
    const init = async () => {
      setVatSettings(await getVATSettings(app))
    }

    init()
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ({
    vatSettings: [vatSettings, updateVATSettings],
    getWarehouses,
    getWarehouseById,
    saveWarehouse,
    deleteWarehouse
  })
}

function SettingsController(props) {
  const settingsController = useSettingsController(props)
  return (
    <React.Fragment>
      <settingsControllerContext.Provider value={settingsController}>
        <SettingsHeader />
        <SettingsInner />
        {/*<SettingsFooter />*/}
      </settingsControllerContext.Provider>
    </React.Fragment>
  )
}

export default React.memo(SettingsController)